export default "__VITE_ASSET__06768e78__"